import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { cn } from '../../../shared/cn';
export type NavbarLabelProps = React.ComponentPropsWithoutRef<'span'> & {
  mobile?: boolean;
};
export function NavbarLabel(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      mobile: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const mobile = t1 === undefined ? false : t1;
  const t2 = mobile ? "text-base leading-6" : "text-sm leading-5";
  let t3;
  if ($[4] !== className || $[5] !== t2) {
    t3 = cn(className, "truncate font-semibold transition-colors", t2);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t3) {
    t4 = <span {...props} className={t3} />;
    $[7] = props;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}